import { defineComponent as _defineComponent } from 'vue'
import PaymentInfoProcessing from '@/components/withdraw-balance/paymentInfoProcessing.vue'
import PaymentSuccess from '@/components/withdraw-balance/paymentSuccess.vue'
import WithdrawForm from '@/components/withdraw-balance/withdrawForm.vue'

import { watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ref, computed } from 'vue'
import { } from '@busy-human/opt-library';
import { httpsCallable } from 'firebase/functions';
import {functions} from '../util/firebase'
import withdrawChoice from '@/components/withdraw-balance/withdrawChoice.vue'
import accountSetup from '@/components/withdraw-balance/accountSetup.vue'
import paymentConfirm from '@/components/withdraw-balance/paymentConfirm.vue'
import withdrawSubmitted from '@/components/withdraw-balance/withdraw-submitted.vue'
import {WidthdrawBalanceStage} from "@/components/withdraw-balance/withdraw-balance";
import withdrawPending from "@/components/withdraw-balance/withdraw-pending.vue";
import { useBalance } from "@/util/balance";
import Loader from '@/components/loader.vue'
import { useUserspace } from '@/store/userspace';

interface PayoutData {
    amount: number;
    currency?: "usd";
    paymentMethodId?: string;
    uid?: string
}

interface CreatePayoutReturn {
    stripePayoutId: string;
    optTransactionId: string;
    amount: number;
    cents: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'withdraw-balance',
  setup(__props, { expose }) {
  expose();


const route = useRoute();
const router = useRouter();

const loading = ref(false)

const noScroll = ref(false)
const userspace = useUserspace();

const charges_enabled = computed(() => userspace.financial.stripe.charges_enabled);
// As confirmation: we're using the actual balance here, not the eventual
//  don't want to allow them to withdraw more than they actually have
const balances = useBalance();
const withdrawalAmount = ref(0);
const disabled = ref(false);

onMounted(() => {
    if(charges_enabled.value && route.params.withdrawParams === "success") {
        // Stripe account is now barely ready to use
        moveToStage(WidthdrawBalanceStage.ACCT_APPROVED_4);
    } else if(charges_enabled.value) {
        // Stripe account ready to use
        moveToStage(WidthdrawBalanceStage.WITHDRAW_FORM_5);
    } else if(userspace.financial.stripe.details_submitted) {
        // Submitted but waiting for Stripe approval
        moveToStage(WidthdrawBalanceStage.ACCT_WAITING_3);
    } else if(route.params.withdrawParams === "refresh") {
        // Not sure if this is correct but if they refresh I believe we want them to try again ?
        moveToStage(WidthdrawBalanceStage.ACCT_CONFIRM_2);
    } else {
        // Setting up for the first time
        moveToStage(WidthdrawBalanceStage.ACCT_SETUP_1);
    }
});


const stage = ref(WidthdrawBalanceStage.ACCT_SETUP_1);

const moveToStage = (value:number) =>{
    // console.log(value)
    if(value == 0){
        routeTo("balance");
    }
    if(value == 1){
        stage.value = WidthdrawBalanceStage.ACCT_SETUP_1;
    }
    if(value == 2){
        stage.value = WidthdrawBalanceStage.ACCT_CONFIRM_2;
    }
    if(value == 3){
        stage.value = WidthdrawBalanceStage.ACCT_WAITING_3;
    }
    if(value == 4){
        stage.value = WidthdrawBalanceStage.ACCT_APPROVED_4;
    }
    if(value == 5){
        stage.value = WidthdrawBalanceStage.WITHDRAW_FORM_5;
    }
    if(value == 6) {
        stage.value = WidthdrawBalanceStage.WITHDRAW_PENDING_6;
    }
    if(value == 7){
        stage.value = WidthdrawBalanceStage.WITHDRAW_SUBMITTED_7;
    }
}

function onAmountChange(amount: number) {
    withdrawalAmount.value = amount;
}

async function onSubmitPayout(amount: number) {
    disabled.value = true;
    loading.value = true;
    withdrawalAmount.value = amount;
    moveToStage(WidthdrawBalanceStage.WITHDRAW_PENDING_6);
    const submitPayout = httpsCallable<PayoutData, CreatePayoutReturn>(functions, 'submitPayout');

    try{
        const result = await submitPayout({amount, uid: useUserspace().uid});

        if(result.data.stripePayoutId){
            moveToStage(WidthdrawBalanceStage.WITHDRAW_SUBMITTED_7);
        } else {
            throw new Error(`Payout missing transaction ID`);
        }

    } catch(err) {
        loading.value = false;
        console.error(err);
        if(err instanceof Error)
            alert(err.message);
    }
    loading.value = false;
    disabled.value = false;
}

watch(() => route.params.withdrawParams, async widthdrawParams => {
    loading.value = true
    if(widthdrawParams) {

    }
    loading.value = false
}, {immediate: true})

const routeTo = (route:string) =>{
    router.push(`/${route}`);
}


const __returned__ = { route, router, loading, noScroll, userspace, charges_enabled, balances, withdrawalAmount, disabled, stage, moveToStage, onAmountChange, onSubmitPayout, routeTo, PaymentInfoProcessing, PaymentSuccess, WithdrawForm, watch, onMounted, useRoute, useRouter, ref, computed, httpsCallable, functions, withdrawChoice, accountSetup, paymentConfirm, withdrawSubmitted, WidthdrawBalanceStage, withdrawPending, useBalance, Loader, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})